import { render, staticRenderFns } from "./stasi.vue?vue&type=template&id=0acecade&scoped=true&"
import script from "./stasi.vue?vue&type=script&lang=js&"
export * from "./stasi.vue?vue&type=script&lang=js&"
import style0 from "./stasi.vue?vue&type=style&index=0&id=0acecade&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acecade",
  null
  
)

export default component.exports